import React, { Component } from "react";
import { observer } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import Courses from "./Courses";
import AdminLinks from "./AdminLinks";
import ProfileStore from "../../stores/ProfileStore";
import { ProfileState } from "../../stores/ProfileStore/Types";
import Icons from "../../components/Profile/components/Icons";
import { ProfileSidebarView } from "../../components/Profile/ProfileSidebar";

interface Props {
  showLoggedInSidebar: boolean;
  handleHideLoggedInSideBar: () => void;
  getCurrentUser: () => void;
  profileStore: ProfileStore;
  currentUser: any;
  userXp: number;
  handleShowProfileSidebar: (val: boolean, view?: ProfileSidebarView) => void;
}

interface State {
  showSettingsModal: boolean;
}
class LoggedInSidebar extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showSettingsModal: false,
    };
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.showLoggedInSidebar !== this.props.showLoggedInSidebar) {
      document.body.style.overflow = this.props.showLoggedInSidebar
        ? "hidden"
        : "";
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
  }
  onClickProfile = () => {
    if (location.pathname === "/profile") {
      this.props.handleHideLoggedInSideBar();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else {
      (window as any).location = "/profile";
    }
  };

  onClickCertificates = () => {
    if (location.pathname === "/profile") {
      this.props.handleHideLoggedInSideBar();
      const certificatesSection = document.getElementById("certificates");
      if (certificatesSection) {
        certificatesSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      (window as any).location = "/profile#certificates";
    }
  };

  onClickSettings = () => {
    this.props.handleHideLoggedInSideBar();
    this.props.handleShowProfileSidebar(true, "settings");
  };

  leaderboardType = (profile) => {
    const leaderboard = profile?.leaderboard_type;

    switch (leaderboard?.name) {
      case "Team":
        return `in ${profile?.team_name}`;
      case "Country":
        return `in ${profile?.country_name}`;
      default:
        return "in the world";
    }
  };

  renderContent = (profileState: ProfileState) => {
    const { currentUser, userXp } = this.props;
    switch (profileState.kind) {
      case "ready":
        if (profileState.profileResource.kind === "current-user-absent") {
          return (
            <div className="ui active inverted dimmer">
              <div className="ui text loader">Loading</div>
            </div>
          );
        } else {
          const { profileResource } = profileState;
          const { handleHideLoggedInSideBar } = this.props;
          const profileName =
            currentUser.kind === "current-user" ? currentUser.name : "";

          return (
            <div className="logged-in-side-bar">
              <div className="drawer-head">
                <span className="drawer-title" id="accountDrawerTitle">
                  Account
                </span>
                <button
                  className="drawer-close"
                  type="button"
                  onClick={() => handleHideLoggedInSideBar()}
                  aria-label="Close account menu"
                >
                  <svg aria-hidden="true">
                    <use href="#icon-close"></use>
                  </svg>
                </button>
              </div>
              <div className="drawer-scroll">
                <div className="view-profile">
                  <div className="pf-head">
                    <div className="pf-avatar">
                      <img
                        src={currentUser?.profile_picture}
                        className="user-image"
                        alt="profile picture"
                      />
                    </div>
                    <div className="pf-id">
                      <div className="nm">{profileName}</div>
                      <div className="meta">
                        <strong>
                          {profileResource?.leaderboard_type?.rank}
                        </strong>{" "}
                        {this.leaderboardType(profileResource)}
                        <span aria-hidden="true">&middot;</span>{" "}
                        <strong>{userXp}</strong> XP
                      </div>
                    </div>
                  </div>

                  <AdminLinks
                    adminUser={profileResource.admin}
                    qaUser={profileResource.qa}
                    superUser={profileResource.super_user}
                  />
                  <Courses />

                  <div className="pf-section pf-refer-section">
                    <Link
                      to="/referrals"
                      className="pf-refer"
                      onClick={() => handleHideLoggedInSideBar()}
                    >
                      <span className="pf-refer-icon">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.7"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 9 H21 V20 a1 1 0 0 1 -1 1 H4 a1 1 0 0 1 -1 -1 z"></path>
                          <path d="M3 6 a1 1 0 0 1 1 -1 H20 a1 1 0 0 1 1 1 V9 H3 z"></path>
                          <path d="M12 5 V21"></path>
                          <path d="M8.5 5 C 7 2.5, 10 1, 12 4 C 14 1, 17 2.5, 15.5 5 H8.5 z"></path>
                        </svg>
                      </span>
                      <span className="pf-refer-text">
                        <span className="pf-refer-title">Refer a friend</span>
                        <span className="pf-refer-sub">
                          Friends get 10% off. You stack up stamps and points.
                        </span>
                      </span>
                    </Link>
                  </div>

                  <div className="pf-links">
                    <button
                      className="pf-link"
                      type="button"
                      onClick={this.onClickProfile}
                    >
                      <svg aria-hidden="true">
                        <use href="#icon-home"></use>
                      </svg>
                      View my homepage
                    </button>
                    <button
                      className="pf-link"
                      type="button"
                      onClick={this.onClickCertificates}
                    >
                      <svg aria-hidden="true" className="ic-line">
                        <use href="#ln-cert"></use>
                      </svg>
                      My certificates
                    </button>
                    <a className="pf-link" href="/courses">
                      <svg aria-hidden="true">
                        <use href="#icon-book"></use>
                      </svg>
                      Browse all courses
                    </a>
                    <a className="pf-link" href="/gift">
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 12v9H4v-9"></path>
                        <path d="M2 7h20v5H2z"></path>
                        <path d="M12 22V7"></path>
                        <path d="M12 7S10.5 2 7.5 3.5 8 7 12 7z"></path>
                        <path d="M12 7s1.5-5 4.5-3.5S16 7 12 7z"></path>
                      </svg>
                      Gift a course or pass
                    </a>
                    <button
                      className="pf-link"
                      type="button"
                      onClick={() => this.onClickSettings()}
                    >
                      <svg aria-hidden="true">
                        <use href="#icon-cog"></use>
                      </svg>
                      Settings
                    </button>
                  </div>

                  <a
                    className="pf-signout"
                    rel="nofollow"
                    data-method="delete"
                    href="/session"
                  >
                    <svg aria-hidden="true">
                      <use href="#icon-signout"></use>
                    </svg>
                    <span>Sign out</span>
                  </a>
                </div>
              </div>
            </div>
          );
        }
        break;
      case "loading":
        return (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        );

      default:
        break;
    }
  };

  render() {
    const { showLoggedInSidebar, profileStore, handleHideLoggedInSideBar } =
      this.props;

    return (
      <div className="logged-in-side-bar">
        <Icons />
        <div
          className={`drawer-backdrop ${showLoggedInSidebar ? "is-open" : ""}`}
          aria-hidden="true"
          onClick={() => handleHideLoggedInSideBar()}
        />
        <aside
          className={`drawer account-drawer ${
            showLoggedInSidebar ? "is-open" : ""
          }`}
          id="account_drawer"
          role="dialog"
          aria-modal="true"
          aria-labelledby="accountDrawerTitle"
          aria-hidden={!showLoggedInSidebar}
        >
          {this.renderContent(profileStore.state)}
        </aside>
      </div>
    );
  }
}

export default observer(LoggedInSidebar);
